import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { setupStore } from './stores'
import { setupDirectives } from './directives'
import 'virtual:uno.css'
import 'element-plus/es/components/overlay/style/css'
import 'element-plus/es/components/message-box/style/css'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/notification/style/css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import './styles/index.scss'

const app = createApp(App)

setupStore(app)
setupDirectives(app)
app.use(router)
app.mount('#app')
